module.exports = __webpack_public_path__ + "img/product_header_2026.a19a0e4e.png";